var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("main-table", {
        attrs: {
          data: _vm.data.tabledata,
          "show-page": false,
          "show-search": false,
          "show-page-size": false,
        },
        scopedSlots: _vm._u([
          {
            key: "name",
            fn: function (scope) {
              return [
                _c(
                  "el-link",
                  {
                    attrs: { underline: false, type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.clickCompany(scope.row.id)
                      },
                    },
                  },
                  [_vm._v(_vm._s(scope.row.name))]
                ),
              ]
            },
          },
          {
            key: "supplierName",
            fn: function (scope) {
              return [
                _c(
                  "el-link",
                  {
                    attrs: { underline: false, type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.clickCompany(scope.row.supplierId)
                      },
                    },
                  },
                  [_vm._v(_vm._s(scope.row.supplierName))]
                ),
              ]
            },
          },
          {
            key: "buyerName",
            fn: function (scope) {
              return [
                _c(
                  "el-link",
                  {
                    attrs: { underline: false, type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.clickCompany(scope.row.buyerId)
                      },
                    },
                  },
                  [_vm._v(_vm._s(scope.row.buyerName))]
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-button", { attrs: { plain: "" }, on: { click: _vm.checkMore } }, [
        _vm._v(_vm._s(_vm.$i18.language("查看更多"))),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }